import {filter, includes, toLower, trim} from 'ramda';
import {isNotNilOrEmpty} from 'ramda-adjunct';

import {RelativeFilterResponseBody} from '../../../../../types/api/api';
import {getPresetDisplayName} from './getPresetDisplayName';

export function filterPresetsBySearch(
  presets: RelativeFilterResponseBody[],
  searchQuery: string | null
): RelativeFilterResponseBody[] {
  if (!isNotNilOrEmpty(trim(searchQuery ?? ''))) {
    return presets;
  }

  const query = toLower(trim(searchQuery ?? ''));

  // Matches the name the user sees — for the system preset that is the translation
  return filter((preset) => includes(query, toLower(getPresetDisplayName(preset))), presets);
}
